export const urls = {
  parametrization: process.env.PARAMETRIZATION_SERVICE,
  issues: process.env.ISSUE_SERVICE,
};
